import React, { useContext } from 'react';
import { Button, Checkbox, OutlinedInput, Typography } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import ImageIcon from '@material-ui/icons/Image';

import { SortableItemContext } from '../ContentItem';

type BannerContentProps = {
	item: any;
};

const BannerContent = ({ item }: BannerContentProps) => {
	const { id, imageUrl, enableCustomHeight, height, mobileHeight } = item;
	const { attributes, listeners, ref } = useContext(SortableItemContext);
	const { expandedId, handleUpdateBanner, handleDeleteContentItem, setExpandedId } = useContext(SortableItemContext);

	const isExpand = expandedId === id;

	return (
		<>
			<div
				{...attributes}
				{...listeners}
				ref={ref}
				style={{
					border: '1px solid #909CA5',
					borderTopLeftRadius: 4,
					borderTopRightRadius: 4,
					borderBottomLeftRadius: isExpand ? 0 : 4,
					borderBottomRightRadius: isExpand ? 0 : 4,
					cursor: 'pointer',
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'space-between',
				}}
				onClick={() => {
					setExpandedId(expandedId === id ? '' : id);
				}}
			>
				<div
					style={{
						display: 'flex',
						justifyContent: 'start',
						alignItems: 'center',
						gap: 10,
						padding: '14px 0 14px 10px',
					}}
				>
					<ImageIcon />
					<Typography variant="body1">Banner</Typography>
				</div>
				<div style={{ display: 'flex' }}>
					<Button
						style={{ minWidth: 0, padding: '14px 10px', borderRadius: 0, borderLeft: '1px solid #909CA5' }}
						onClick={(e) => {
							e.stopPropagation();
							e.preventDefault();
							handleDeleteContentItem(id);
						}}
					>
						<CloseIcon fontSize="small" />
					</Button>
				</div>
			</div>
			{isExpand && (
				<div
					style={{
						borderLeft: '1px solid #909CA5',
						borderRight: '1px solid #909CA5',
						borderBottom: '1px solid #909CA5',
						borderTopLeftRadius: 0,
						borderTopRightRadius: 0,
						borderBottomLeftRadius: 4,
						borderBottomRightRadius: 4,
						padding: '14px 10px',
					}}
				>
					<Typography variant="body1" style={{ marginBottom: 5 }}>
						Image URL
					</Typography>
					<OutlinedInput
						fullWidth
						placeholder="https://..."
						value={imageUrl ?? ''}
						onChange={(event: React.ChangeEvent<{ name?: string; value: unknown }>) => {
							handleUpdateBanner('imageUrl', event.target.value as string);
						}}
					/>
					<div style={{ display: 'flex', alignItems: 'center', marginTop: 10 }}>
						<Checkbox
							id="banner-custom-height"
							color="primary"
							checked={!!enableCustomHeight}
							size="small"
							onChange={(_, checked: boolean) => {
								handleUpdateBanner('enableCustomHeight', checked);
							}}
						/>
						<label htmlFor="banner-custom-height">Custom height</label>
					</div>
					<Typography variant="caption" style={{ display: 'block', marginLeft: 10, color: '#909CA5' }}>
						Leave unchecked to show the banner in the natural height of the image.
					</Typography>

					{enableCustomHeight && (
						<div style={{ display: 'flex', gap: 10, marginTop: 10 }}>
							<div style={{ flex: 1 }}>
								<Typography variant="body1" style={{ marginBottom: 5 }}>
									Desktop (px)
								</Typography>
								<OutlinedInput
									fullWidth
									type="number"
									placeholder="Auto"
									inputProps={{ min: 0 }}
									value={height ?? ''}
									onChange={(event: React.ChangeEvent<{ name?: string; value: unknown }>) => {
										const value = event.target.value as string;
										handleUpdateBanner('height', value === '' ? '' : Number(value));
									}}
								/>
							</div>
							<div style={{ flex: 1 }}>
								<Typography variant="body1" style={{ marginBottom: 5 }}>
									Mobile (px)
								</Typography>
								<OutlinedInput
									fullWidth
									type="number"
									placeholder="Auto"
									inputProps={{ min: 0 }}
									value={mobileHeight ?? ''}
									onChange={(event: React.ChangeEvent<{ name?: string; value: unknown }>) => {
										const value = event.target.value as string;
										handleUpdateBanner('mobileHeight', value === '' ? '' : Number(value));
									}}
								/>
							</div>
						</div>
					)}

					{!!imageUrl && (
						<img
							src={imageUrl}
							alt="Banner preview"
							style={{ marginTop: 10, width: '100%', height: 'auto', objectFit: 'contain' }}
							onError={(event) => {
								(event.target as HTMLImageElement).style.display = 'none';
							}}
							onLoad={(event) => {
								(event.target as HTMLImageElement).style.display = 'block';
							}}
						/>
					)}
				</div>
			)}
		</>
	);
};

export default BannerContent;
